import React, { FC, SVGProps, useContext } from 'react';
import classNames from 'classnames';
import { RegisteredIconContext } from './IconRegistry';
import './icon.css';

import { ReactComponent as addUser } from '../../assets/icons/addUser.js';
import { ReactComponent as analytics } from '../../assets/icons/analytics.js';
import { ReactComponent as android } from '../../assets/icons/android.js';
import { ReactComponent as apple } from '../../assets/icons/apple.js';
import { ReactComponent as apps } from '../../assets/icons/apps.js';
import { ReactComponent as archive } from '../../assets/icons/archive.js';
import { ReactComponent as arrowDown } from '../../assets/icons/arrowDown.js';
import { ReactComponent as arrowLeft } from '../../assets/icons/arrowLeft.js';
import { ReactComponent as arrowRight } from '../../assets/icons/arrowRight.js';
import { ReactComponent as arrowUp } from '../../assets/icons/arrowUp.js';
import { ReactComponent as bell } from '../../assets/icons/bell.js';
import { ReactComponent as bellRing } from '../../assets/icons/bellRing.js';
import { ReactComponent as block } from '../../assets/icons/block.js';
import { ReactComponent as chat } from '../../assets/icons/chat.js';
import { ReactComponent as check } from '../../assets/icons/check.js';
import { ReactComponent as checkbox } from '../../assets/icons/checkbox.js';
import { ReactComponent as checkboxFilled } from '../../assets/icons/checkboxFilled.js';
import { ReactComponent as chevronDown } from '../../assets/icons/chevronDown.js';
import { ReactComponent as chevronLeft } from '../../assets/icons/chevronLeft.js';
import { ReactComponent as chevronRight } from '../../assets/icons/chevronRight.js';
import { ReactComponent as chevronUp } from '../../assets/icons/chevronUp.js';
import { ReactComponent as clock } from '../../assets/icons/clock.js';
import { ReactComponent as clockFilled } from '../../assets/icons/clockFilled.js';
import { ReactComponent as close } from '../../assets/icons/close.js';
import { ReactComponent as company } from '../../assets/icons/company.js';
import { ReactComponent as concessionManager } from '../../assets/icons/concessionManager.js';
import { ReactComponent as copy } from '../../assets/icons/copy.js';
import { ReactComponent as creditCard } from '../../assets/icons/creditCard.js';
import { ReactComponent as deal } from '../../assets/icons/deal.js';
import { ReactComponent as download } from '../../assets/icons/download.js';
import { ReactComponent as drag } from '../../assets/icons/drag.js';
import { ReactComponent as error } from '../../assets/icons/error.js';
import { ReactComponent as expand } from '../../assets/icons/expand.js';
import { ReactComponent as eye } from '../../assets/icons/eye.js';
import { ReactComponent as facebook } from '../../assets/icons/facebook.js';
import { ReactComponent as filePDF } from '../../assets/icons/filePDF.js';
import { ReactComponent as fileExcel } from '../../assets/icons/fileExcel.js';
import { ReactComponent as filter } from '../../assets/icons/filter.js';
import { ReactComponent as flame } from '../../assets/icons/flame.js';
import { ReactComponent as hamburger } from '../../assets/icons/hamburger.js';
import { ReactComponent as help } from '../../assets/icons/help.js';
import { ReactComponent as home } from '../../assets/icons/home.js';
import { ReactComponent as inbox } from '../../assets/icons/inbox.js';
import { ReactComponent as income } from '../../assets/icons/income.js';
import { ReactComponent as laptop } from '../../assets/icons/laptop.js';
import { ReactComponent as lifeRing } from '../../assets/icons/lifeRing.js';
import { ReactComponent as location } from '../../assets/icons/location.js';
import { ReactComponent as mailOutline } from '../../assets/icons/mailOutline.js';
import { ReactComponent as menu } from '../../assets/icons/menu.js';
import { ReactComponent as navigation } from '../../assets/icons/navigation.js';
import { ReactComponent as paintBrush } from '../../assets/icons/paintBrush.js';
import { ReactComponent as partner } from '../../assets/icons/partner.js';
import { ReactComponent as pencil } from '../../assets/icons/pencil.js';
import { ReactComponent as phone } from '../../assets/icons/phone.js';
import { ReactComponent as phoneCheck } from '../../assets/icons/phoneCheck.js';
import { ReactComponent as phoneRing } from '../../assets/icons/phoneRing.js';
import { ReactComponent as plus } from '../../assets/icons/plus.js';
import { ReactComponent as profile } from '../../assets/icons/profile.js';
import { ReactComponent as radio } from '../../assets/icons/radio.js';
import { ReactComponent as radioFilled } from '../../assets/icons/radioFilled.js';
import { ReactComponent as resize } from '../../assets/icons/resize.js';
import { ReactComponent as schedule } from '../../assets/icons/schedule.js';
import { ReactComponent as search } from '../../assets/icons/search.js';
import { ReactComponent as settings } from '../../assets/icons/settings.js';
import { ReactComponent as sms } from '../../assets/icons/sms.js';
import { ReactComponent as successMessage } from '../../assets/icons/successMessage.js';
import { ReactComponent as threeDots } from '../../assets/icons/threeDots.js';
import { ReactComponent as touch } from '../../assets/icons/touch.js';
import { ReactComponent as trash } from '../../assets/icons/trash.js';
import { ReactComponent as twitter } from '../../assets/icons/twitter.js';
import { ReactComponent as unfold } from '../../assets/icons/unfold.js';
import { ReactComponent as user } from '../../assets/icons/user.js';
import { ReactComponent as users } from '../../assets/icons/users.js';
import { ReactComponent as video } from '../../assets/icons/video.js';
import { ReactComponent as warning } from '../../assets/icons/warning.js';

export const defaultIcons = {
  addUser,
  analytics,
  android,
  apps,
  apple,
  archive,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  bell,
  bellRing,
  block,
  chat,
  check,
  checkbox,
  checkboxFilled,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  clock,
  clockFilled,
  close,
  company,
  concessionManager,
  copy,
  creditCard,
  deal,
  download,
  drag,
  error,
  expand,
  eye,
  facebook,
  fileExcel,
  filePDF,
  filter,
  flame,
  hamburger,
  help,
  home,
  inbox,
  income,
  laptop,
  lifeRing,
  location,
  mailOutline,
  menu,
  navigation,
  paintBrush,
  partner,
  pencil,
  phone,
  phoneCheck,
  phoneRing,
  plus,
  profile,
  radio,
  radioFilled,
  resize,
  schedule,
  search,
  settings,
  sms,
  successMessage,
  threeDots,
  touch,
  trash,
  twitter,
  unfold,
  user,
  users,
  video,
  warning
};

const aliasMap = {
  confirmationEmail: 'successMessage',
  excel: 'fileExcel',
  support: 'lifeRing',
  notifications: 'bellRing',
  pdf: 'filePDF',
  ringVolume: 'phoneRing',
  visibility: 'eye',
  question: 'help'
};

export type IconsMap = { [x: string]: FC<SVGProps<SVGSVGElement>> };
export type DefaultIconNames = keyof typeof defaultIcons;
export type AliasIconNames = keyof typeof aliasMap;
export type IconNames = DefaultIconNames | AliasIconNames | string;

export interface IconProps {
  className?: string;
  name: IconNames;
  viewBox?: string;
}

export const Icon: FC<IconProps> = ({ className, name, viewBox = '0 0 24 24', ...props }) => {
  const registeredIcons = useContext(RegisteredIconContext);

  const icons: IconsMap = {
    ...defaultIcons,
    ...registeredIcons
  };

  if (!name) {
    throw new Error(`You must provide a valid "name" prop to the "Icon" component.`);
  }

  if (!icons[name]) {
    if ((aliasMap as { [x: string]: DefaultIconNames })[name])
      name = (aliasMap as { [x: string]: DefaultIconNames })[name];
    else {
      throw new Error(`Icon with name "${name}" does not exist.`);
    }
  }

  const IconSvg = icons[name];

  return (
    <span className={classNames('lc-icon', `lc-icon-${name}`, className)} {...props}>
      <IconSvg viewBox={viewBox ? viewBox : undefined} />
    </span>
  );
};
